import { createTheme } from '@mui/material/styles';
import { lifeTaggerDesign } from './tokens';

export const lifeTaggerTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: lifeTaggerDesign.color.moss },
    secondary: { main: lifeTaggerDesign.color.action },
    background: {
      default: lifeTaggerDesign.color.canvas,
      paper: lifeTaggerDesign.color.paper,
    },
    text: {
      primary: lifeTaggerDesign.color.ink,
      secondary: lifeTaggerDesign.color.muted,
    },
    divider: lifeTaggerDesign.color.border,
  },
  typography: {
    fontFamily: lifeTaggerDesign.type.body,
    h1: { fontFamily: lifeTaggerDesign.type.headline, fontWeight: 400 },
    h2: { fontFamily: lifeTaggerDesign.type.headline, fontWeight: 400 },
    h3: { fontFamily: lifeTaggerDesign.type.headline, fontWeight: 400 },
    h4: { fontFamily: lifeTaggerDesign.type.headline, fontWeight: 400 },
    h5: { fontFamily: lifeTaggerDesign.type.headline, fontWeight: 400 },
    h6: { fontFamily: lifeTaggerDesign.type.headline, fontWeight: 400 },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  shape: { borderRadius: lifeTaggerDesign.radius.control },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 999, paddingInline: 18 },
        contained: { boxShadow: 'none' },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { backgroundColor: lifeTaggerDesign.color.paper },
      },
    },
  },
});
